var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { COLORS, FONT } from '../../constants';
export var tagStyles = __assign(__assign({
  display: 'flex',
  alignItems: 'center',
  margin: '8px 8px 0 0',
  padding: '3px 6px',
  boxSizing: 'border-box',
  color: COLORS.grays.dark
}, FONT.sizes.small), {
  fontFamily: FONT.family,
  letterSpacing: '0.5px',
  backgroundColor: COLORS.grays.lightest,
  border: "1px solid " + COLORS.grays.cardBorder,
  borderRadius: 2
});
export var removeIconStyles = {
  width: 12,
  height: 12,
  marginLeft: 6,
  cursor: 'pointer',
  fill: COLORS.grays.gray,
  transition: 'fill .1s',
  '&:hover': {
    fill: COLORS.grays.dark
  }
};
export var addTagStyles = __assign(__assign({}, tagStyles), {
  background: COLORS.white,
  transition: 'border-color .1s, color .1s',
  '&:hover, &:focus': {
    cursor: 'pointer',
    background: COLORS.white,
    borderColor: COLORS.blues.primary,
    color: COLORS.blues.primary
  },
  '&:focus': {
    padding: '2px 5px',
    borderWidth: 2,
    boxShadow: "0 0px 0px 2px " + COLORS.blues.lightest,
    outline: 'none'
  }
});
export var inputStyles = {
  '&[type]': __assign(__assign({}, FONT.sizes.small), {
    height: '24px',
    paddingTop: '2px',
    paddingBottom: '2px',
    borderRadius: '2px 0 0 2px',
    borderRight: 0,
    outline: 'none',
    '&:hover, &:focus': {
      borderColor: COLORS.blues.primary,
      borderRight: 0,
      boxShadow: 'none'
    }
  })
};
export var buttonStyles = __assign(__assign({}, FONT.sizes.small), {
  height: '24px',
  borderRadius: '0 2px 2px 0',
  paddingTop: '0',
  paddingBottom: '0'
});
export var suggestionListStyles = {
  backgroundColor: COLORS.white,
  border: "1px solid " + COLORS.grays.cardBorder,
  left: 0,
  maxHeight: 84,
  overflowY: 'auto',
  position: 'absolute',
  top: '100%',
  width: '100%',
  zIndex: 10,
  listStyle: 'none',
  margin: 0
};
export var suggestionListItemStyles = {
  color: COLORS.grays.darkest,
  fontSize: 14,
  lineHeight: '20px',
  overflow: 'hidden',
  padding: '6px 16px 6px 8px',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  '&:hover': {
    backgroundColor: COLORS.grays.background,
    cursor: 'pointer'
  }
};
export var closeLinkStyles = __assign(__assign({
  margin: '0 0 0 3px',
  padding: '0'
}, FONT.sizes.regular), {
  fontFamily: FONT.family,
  textAlign: 'left',
  textDecoration: 'none',
  border: '2px solid transparent',
  borderRadius: '2px',
  outline: 'none',
  color: COLORS.grays.dark,
  background: 'transparent',
  '&:hover,&:focus': {
    cursor: 'pointer',
    color: COLORS.grays.darkest,
    background: 'inherit'
  },
  '&:focus': {
    borderColor: COLORS.grays.darkest
  },
  '&:visited': {
    color: COLORS.grays.dark
  },
  '&:visited:hover,&:visited:focus': {
    color: COLORS.grays.darkest
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Tags/styles.js
// module id = 398
// module chunks = 0